module.exports = __webpack_public_path__ + "img/product-sm-4.d9763a07.png";